// extracted by mini-css-extract-plugin
export default {"container":"styles_container__61UEe","sigContainer":"styles_sigContainer__5i5GZ","sigPad":"styles_sigPad__e-pPS","sigImage":"styles_sigImage__tquxb"};